import React, { memo } from 'react';

import { areEqual } from 'Utils/equalityChecks';

import { NoteCard } from 'Components/Notes';
import { compareTwoDates, convertWordsFirstLetterUppercase, formatDate } from 'Utils/helpers';

interface Props {
  id: number;
  note: any;
  isReadOnly: boolean;
}

const getNoteDate = (createdAt) => `${formatDate(createdAt, 'MMM d')} at ${formatDate(createdAt, 'h:mmaaa')}`;
const getPostedBy = (fullName) => convertWordsFirstLetterUppercase(fullName);

function PhotoShareNoteCardContainer({ id, note, isReadOnly }: Props) {
  const {
    created_at: createdAt,
    body: noteContent,
    is_flagged: isFlagged,
    is_bookmarked: isBookmarked,
    updated_at: updatedAt,
  } = note;

  let fullName = '[deleted user]';
  if (note.author) {
    fullName = note.author.full_name;
  }

  const postedByName = getPostedBy(fullName);
  const datePosted = getNoteDate(createdAt);
  const dateEdited = compareTwoDates(createdAt, updatedAt) ? '' : getNoteDate(updatedAt);

  return (
    <NoteCard
      id={id}
      canModify={isReadOnly}
      canDelete={isReadOnly}
      postedByName={postedByName}
      datePosted={datePosted}
      dateEdited={dateEdited}
      content={noteContent}
      bookmarked={isBookmarked}
      flagged={isFlagged}
    />
  );
}

const PhotoShareNoteCardContainerMemo = memo(PhotoShareNoteCardContainer, areEqual);

export { PhotoShareNoteCardContainerMemo as PhotoShareNoteCard };
